// eslint-disable-next-line import/no-anonymous-default-export
export default {
    baseUrl:"https://pscapi.devssh.xyz/api/",
    // baseUrl:"https://pscapi.devssh.xyz/api/",

   }

// http://cnchub.pythonanywhere.com/webapi 